import React, { useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import moment from "moment";

const TaskCycle = ({ data }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className="task-timer">
            <Button
                onClick={() => setOpen(!open)}
                aria-controls="example-collapse-text"
                aria-expanded={open}
            >
                Ժամանակաչափի աշխատանքը
            </Button>
            <Collapse in={open}>
                <div id="example-collapse-text">
                    <table>
                        <thead>
                        <tr>
                            <th>Վերսկսել</th>
                            <th>Դադար</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data?.task_timer?.map((item, index) => (
                            <tr className="task-timer-item" key={index}>
                                <td className="timer-start-end">
                                    {item.start && (
                                        <div>
                                                <span className="task-timer-item-date">
                                                    {moment(item.start).format('L')}
                                                </span>
                                            <span>
                                                    {moment(item.start).format('LTS')}
                                                </span>
                                        </div>
                                    )}
                                </td>
                                <td className="timer-start-end">
                                    {item.end && (
                                        <div>
                                                <span className="task-timer-item-date">
                                                    {moment(item.start).format('L')}
                                                </span>
                                            <span>
                                                    {moment(item.end).format('LTS')}
                                                </span>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </Collapse>
        </div>
    );
};

export default TaskCycle;
